import type { LinkingMatrix } from '../types';

export const MATRIX: LinkingMatrix = {
    results: [],
    watchlist: [],
    'order-blotter': [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'positions',
        'executions',
        'orders',
        'alpha-lens',
    ],
    'trade-pro': [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'basket-trading',
        'messages',
        'positions',
        'executions',
        'orders',
        'lab',
        'alpha-lens',
    ],
    'trade-pro-multi': [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'basket-trading',
        'messages',
        'positions',
        'executions',
        'orders',
        'lab',
        'alpha-lens',
    ],
    'basket-trading': [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'basket-trading',
        'messages',
        'positions',
        'executions',
        'orders',
        'lab',
        'alpha-lens',
    ],
    'manual-review': [],
    messages: ['order-blotter', 'trade-pro', 'trade-pro-multi', 'messages', 'positions', 'executions', 'orders'],
    positions: [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'basket-trading',
        'messages',
        'positions',
        'executions',
        'orders',
        'lab',
        'alpha-lens',
    ],
    executions: ['messages', 'trade-pro', 'trade-pro-multi', 'executions', 'alpha-lens'],
    accounts: [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'basket-trading',
        'messages',
        'positions',
        'executions',
        'orders',
        'lab',
    ],
    orders: [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'basket-trading',
        'messages',
        'executions',
        'orders',
        'alpha-lens',
    ],
    lab: ['trade-pro', 'trade-pro-multi', 'lab'],
    table: [],
    'alpha-lens': [],
    searchalpha: [],
    scanner: [],
    screener: [],
    news: [],
    events: [],
    filings: [],
    notepad: [],
    'alpha-eye': [],
    platforms: [],
    symbols: [],
    traders: [],
    alerts: [],
    backtest: [],
    'tradingview-chart': [],
};
